import './LineItemGroupHeader.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import { formatStringDate } from '../../../../../../utils/formatting';
import ExpandToggle from '../ExpandToggle/ExpandToggle';
import UnmappedLabel from './UnmappedLabel/UnmappedLabel';

const [block, element] = bem('line-item-group-header');

type LineItemGroupHeaderProps = {
  label: string;
  isUnmapped: boolean;
  adCount: number;
  startDate?: string | null;
  endDate?: string | null;
  isExpanded: boolean;
  onToggle: () => void;
};

const LineItemGroupHeader = ({
  label,
  isUnmapped,
  adCount,
  startDate,
  endDate,
  isExpanded,
  onToggle,
}: LineItemGroupHeaderProps): React.JSX.Element => {
  return (
    <tr className={block(isUnmapped ? 'unmapped' : '')}>
      <td className={element('name')} colSpan={6}>
        <span className={element('name-content')}>
          <ExpandToggle isExpanded={isExpanded} onToggle={onToggle} />
          {isUnmapped ? (
            <UnmappedLabel label={label} adCount={adCount} />
          ) : (
            <span className={element('label')}>{label}</span>
          )}
        </span>
      </td>
      <td className={element('date')}>{formatStringDate(startDate ?? null)}</td>
      <td className={element('date')}>{formatStringDate(endDate ?? null)}</td>
      <td className={element('action')} />
    </tr>
  );
};

export default LineItemGroupHeader;
